import { createNote } from './create'
import { deleteNote } from './delete'
import { resourceObject } from './resourceObject'
import { updateNote } from './update'

export const note = {
  create: createNote,
  delete: deleteNote,
  update: updateNote,
  clientResource: resourceObject,
}

export type { CreateNoteRequestBody, CreateNoteParams } from './create'
export type {
  UpdateNoteParams,
  UpdateNoteRequestBody,
  UpdateNoteRequestArgs,
} from './update'
export type { DeleteNoteParams } from './delete'
